import type { ReactNode } from 'react';

export const EmptyState = ({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) => (
  <div className="rounded-xl bg-raised px-6 py-10 text-center">
    <p className="text-base font-semibold text-content">{title}</p>
    {description ? (
      <p className="mx-auto mt-2 max-w-prose text-sm text-muted">{description}</p>
    ) : null}
    {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
  </div>
);
